import React from "react";

import "./PTEfluente.css";

export default function PTEfluente() {
  return <></>;
}
